import styled from "styled-components";

const SidebarMenuContainer = styled.div`
  .ant-layout-header {
    padding: 0 30px;
    height: 80px;
  }
  .logo {
    display: flex;
    align-items: center;
  }
  .logo > span svg {
    font-size: 25px;
    color: #fff;
    margin-right: 16px;
    transition: color 0.2s;
    margin-top: 15px;
  }
`;

export { SidebarMenuContainer };
